import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { useIntl, FormattedMessage } from "react-intl";
import { AppContext } from "contexts/app";
import stylesLess from "./index.module.less";
import axios from "utils/axios";
import sessionStorage from "utils/sessionStorage";
import cookie from "utils/cookie";
import LocalStorage from "utils/localStorage";
import { getAbsoluteUrl } from "utils/method";
import {
  regexp,
  doRsaEncrypt,
  getExplore,
  browserRedirect,
  getUUID,
  redirectBackUrl,
} from "utils/method";
import {
  post_loginByFaBeforeCheck,
  post_passwdPublicKey,
  get_qr,
  get_qrResult,
} from "api/uaapi/uaa";

import AntdModalAlert from "components/Antd/Modal/Alert";
import ButtonBig from "components/Antd/Button/big";
import FormItem from "components/App/FormItem";
import FormItemInput from "components/App/FormItem/Input";
import FormItemPassword from "components/App/FormItem/Password";
import CountryList from "components/App/Country";
import Geetest from "components/Geetest";
import QRCode from "qrcode.react";

import imgLogo_dark from "assets/images/sao-dark.svg";
import imgLogo_light from "assets/images/sao-light.svg";
// import logo from "../../../../public/logo.png";
import correct from "assets/images/correct.svg";

import jsrsasign, { KEYUTIL, KJUR, RSAKey } from "jsrsasign";

export default function Register() {
  const intl = useIntl();
  const router = useRouter();
  const [appState, appDispatch] = React.useContext(AppContext);

  const [state_type, setState_type] = React.useState("email");
  const [qrUrl, setQrUrl] = React.useState("1");
  const [publicKey, setPublicKey] = React.useState("");
  const [privateKey, setPrivateKey] = React.useState("");
  const [sign, setSign] = React.useState(Date.now());
  const [qrKey, setQrKey] = React.useState("");
  const [status, setStatus] = React.useState("NEW");
  const imgLogo = appState.isDark ? imgLogo_dark : imgLogo_light;

  const getQrResult = async () => {
    console.log("qrKey:", qrKey);
    console.log("privateKey:", privateKey);
    const timestamp = Date.now();
    console.log(
      "timestamp=${timestamp}&qrKey=${qrKey}",
      `timestamp=${timestamp}&qrKey=${qrKey}`
    );
    const appSecret =
      "-----BEGIN PRIVATE KEY-----" + privateKey + "-----END PRIVATE KEY-----";
    let rsa = new RSAKey();
    rsa = KEYUTIL.getKey(appSecret);
    // 创建Signature对象，设置签名编码算法
    let sig = new KJUR.crypto.Signature({ alg: "SHA1withRSA" });
    // 初始化
    sig.init(rsa);
    // 传入待加密字符串
    sig.updateString(`timestamp=${timestamp}&qrKey=${qrKey}`);
    // 生成密文
    let sign = jsrsasign.hextob64(sig.sign());
    // 对加密后内容进行URI编码
    // let sign1 = encodeURIComponent(sign);
    console.log("验签：", sign);
    let deviceId = "";
    if (LocalStorage.get("client-device-id")) {
      deviceId = LocalStorage.get("client-device-id");
    } else {
      deviceId = getUUID();
      LocalStorage.set("client-device-id", deviceId);
    }
    LocalStorage.get("client-device-id");
    const deviceIdPublicKey = await axios.asyncAwait(post_passwdPublicKey, {
      errorPop: true,
    });
    try {
      const result = await get_qrResult({
        headers: {
          "client-device-id": doRsaEncrypt(
            deviceIdPublicKey.data.publicKey,
            deviceId
          ),
          "client-device-name": `${getExplore()} (${browserRedirect()})`,
        },
        params: {
          qrKey,
          timestamp,
          sign,
          passwdId: deviceIdPublicKey.data.passwdId,
        },
      });
      console.log("get_qrResult", result);
      if (!result) {
        setStatus("NEW");
        return;
      }
      if (result.loginStatus === 7) {
        setStatus("scanSuccess");
        return;
      }
      if (result.loginStatus === 1) {
        //登录成功
        sessionStorage.set("token", result.accessToken);
        cookie.set("token", result.accessToken);
        cookie.set("theme", appState.isDark ? "dark" : "light");
        stopTimer();
        try {
          sensors.login(data.userVO.userId);
        } catch (e) {
          //
        }

        if (
          result.userVO &&
          !result.userVO.regCountryId &&
          !result.userVO.kycAuthCountryId
        ) {
          if (typeof location !== "undefined")
            location.replace(
              getAbsoluteUrl({
                pathname: "/country",
                locale: router.locale,
                query: router.query,
              })
            );
          else
            router.replace({
              pathname: "/country",
              query: router.query,
            });
        } else {
          redirectBackUrl(router);
        }
      }
    } catch (error) {
      if (error.code == 921) {
        setStatus("EXPIRED");
        stopTimer();
      }
      console.log("error!!!!", error);
    }
  };

  let timer = React.useRef();

  React.useEffect(() => {
    sessionStorage.remove("puzzleValidateString");
  }, []);

  React.useEffect(() => {
    startTimer(); // 开启定时器
    return () => {
      stopTimer();
    };
  }, [qrKey]);

  // React.useEffect(()=>{
  //   if(status == "EXPIRED") {
  //     stopTimer()
  //   }
  // }, [status])

  // 开启定时器
  const startTimer = () => {
    console.log("开启定时器!!!!!");
    timer.current = setInterval(() => {
      getQrResult();
    }, 5000);
  };

  // 关闭
  const stopTimer = () => {
    console.log("关闭定时器!!!!!");
    clearInterval(timer.current);
  };

  const getQrCode = async () => {
    const result = await get_qr({
      headers: {
        "client-device-name": `${getExplore()} (${browserRedirect()})`,
      },
    });
    console.log("result:", result);
    setQrKey(result.qrKey);
    let privateDer = result.privateKey;
    privateDer = privateDer.replace(/\n/g, "");
    privateDer = privateDer.replace("-----BEGIN RSA PRIVATE KEY-----", "");
    privateDer = privateDer.replace("-----END RSA PRIVATE KEY-----", "");
    setPrivateKey(privateDer);
    console.log("qrUrl:", `${result.qrKey}&qrLogin`);
    setQrUrl(`${result.qrKey}&qrLogin`);
  };

  React.useEffect(() => {
    try {
      sensors.track("LoginPage", {
        from_page: router.query.backurl || "",
      });
    } catch (error) {}
    create_key();
  }, []);

  const create_key = () => {
    setStatus("NEW");
    getQrCode();
  };

  React.useEffect(() => {
    return;
    if (state_type) {
      LocalStorage.set("loginType", state_type);
    } else {
      let loginType = LocalStorage.get("loginType");
      loginType = /^(email|mobile)$/.test(loginType) ? loginType : "email";
      setState_type(loginType);
    }
    console.log("React.useEffect state_type", state_type);
    setState_email("");
    setState_mobile("");
    setState_password("");
  }, [state_type]);

  const [state_email, setState_email] = React.useState("");
  const [state_email_status, setState_email_status] = React.useState({
    isOK: false,
    errMsg: "",
  });
  const verify_email = (bool) => {
    const newVal = state_email;
    const errMsg = intl.formatMessage({ id: "register.plsInputCorrectEmail" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("email", newVal)) {
      status = {
        isOK: false,
        errMsg: errMsg,
      };
    }

    setState_email_status(status);
    return status;
  };
  React.useEffect(() => {
    // verify_email();
    setState_email_status({ isOK: false, errMsg: "" });
  }, [state_email]);

  const [state_countryCode, setState_countryCode] = React.useState("91");
  const [state_mobile, setState_mobile] = React.useState("");
  const handleInputMobile = (val) => {
    if (/^[0-9]*$/.test(val)) setState_mobile(val);
  };
  const [state_mobile_status, setState_mobile_status] = React.useState({
    isOK: false,
    errMsg: "",
  });
  const verify_mobile = (bool) => {
    const newVal = state_mobile;
    const errMsg = intl.formatMessage({ id: "register.plsInputCorrectPhone" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    } else if (!regexp("phone", newVal)) {
      status = {
        isOK: false,
        errMsg: intl.formatMessage({ id: "register.plsInputCorrectPhone" }),
      };
    }

    setState_mobile_status(status);
    return status;
  };
  React.useEffect(() => {
    // verify_mobile();
    setState_mobile_status({ isOK: false, errMsg: "" });
  }, [state_mobile]);

  const [state_password, setState_password] = React.useState("");
  const [state_password_status, setState_password_status] = React.useState({
    isOK: false,
    errMsg: "",
  });
  const verify_password = (bool) => {
    const newVal = state_password;
    const errMsg = intl.formatMessage({ id: "register.plsInputPwd" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal) {
      status = { isOK: false, errMsg: bool ? errMsg : "" };
    }

    setState_password_status(status);
    return status;
  };
  React.useEffect(() => {
    // verify_password();
    setState_password_status({ isOK: false, errMsg: "" });
  }, [state_password]);

  const [state_loading, setState_loading] = React.useState(false);
  const verify = () => {
    let isOK = true;
    if (state_type === "email") {
      const status = verify_email(true);
      !status.isOK && (isOK = false);
    } else if (state_type === "mobile") {
      const status = verify_mobile(true);
      !status.isOK && (isOK = false);
    }
    const status = verify_password(true);
    !status.isOK && (isOK = false);

    return isOK;
  };
  const handleSubmit = () => {
    if (state_loading) return;
    if (!verify()) return;
    geetestRef.current.verify();
  };
  const geetestRef = React.useRef();
  const handleGeetestSuccess = async (puzzleValidateString) => {
    setState_loading(true);

    let deviceId = "";
    if (LocalStorage.get("client-device-id")) {
      deviceId = LocalStorage.get("client-device-id");
    } else {
      deviceId = getUUID();
      LocalStorage.set("client-device-id", deviceId);
    }

    const passwdPublicKey = await axios.asyncAwait(post_passwdPublicKey, {
      errorPop: true,
    });
    if (passwdPublicKey.err) return setState_loading(false);

    const send = {
      userName: state_type === "email" ? state_email : state_mobile,
      countryCode: state_type === "email" ? undefined : state_countryCode,
      loginPwd: doRsaEncrypt(passwdPublicKey.data.publicKey, state_password),
      passwdId: passwdPublicKey.data.passwdId,
      puzzleValidateString,
      // regChannel: "xt",
      version: "2.0",
    };

    const { err, data } = await axios.asyncAwait(post_loginByFaBeforeCheck, {
      headers: {
        "client-device-id": doRsaEncrypt(
          passwdPublicKey.data.publicKey,
          deviceId
        ),
        "client-device-name": `${getExplore()} (${browserRedirect()})`,
      },
      data: send,
      errorPop: true,
      // successPop: true,
    });
    setState_loading(false);
    if (err) return;
    try {
      sensors.track("LoginButtonClick", {
        login_method: state_type === "email" ? "邮箱" : "手机",
      });
    } catch (error) {}

    sessionStorage.set("2fa", data);
    sessionStorage.set("puzzleValidateString", puzzleValidateString);

    if (typeof location !== "undefined")
      return (location.href = getAbsoluteUrl({
        pathname: "/login/2fa",
        locale: router.locale,
        query: router.query,
      }));
    router.push({
      pathname: "/login/2fa",
      query: router.query,
    });
  };

  return (
    <div className={`${stylesLess.main} ${appState.isDark ? "dark" : "light"}`}>
      {/*{qrUrl && (*/}
        <div className="left" style={{ flexBasis: "400px" }}>
          <h1 className="iHead">
            <FormattedMessage id="app.saas.welcomeToAlpha" />
          </h1>
          {/*<div className="iDesc">*/}
          {/*  <FormattedMessage id="register.welcomeToXTTip" />*/}
          {/*</div>*/}

          <div className={"iForm"}>
            <div className="iNav">
              <button
                className={`btntxt loginBtn ${
                  appState.isDark ? "dark" : "light"
                } ${state_type === "email" ? "atv" : ""}`}
                disabled={state_loading}
                onClick={() => setState_type("email")}
              >
                <FormattedMessage id="app.email" />
              </button>
              <button
                className={`btntxt loginBtn ${
                  appState.isDark ? "dark" : "light"
                } ${state_type === "mobile" ? "atv" : ""}`}
                disabled={state_loading}
                onClick={() => setState_type("mobile")}
              >
                <FormattedMessage id="app.mobile" />
              </button>
            </div>

            {state_type === "email" && (
              <FormItem
                title={<FormattedMessage id="app.email" />}
                errMsg={state_email_status.errMsg}
              >
                <FormItemInput
                  autoComplete={"on"}
                  isErr={!!state_email_status.errMsg}
                  // placeholder={intl.formatMessage({
                  //   id: "app.email",
                  // })}
                  disabled={state_loading}
                  value={state_email}
                  onInput={(val) => setState_email(val.replace(/\s*/g, ""))}
                  onBlur={() => verify_email(1)}
                />
              </FormItem>
            )}
            {state_type === "mobile" && (
              <FormItem
                title={<FormattedMessage id="app.mobile" />}
                errMsg={state_mobile_status.errMsg}
              >
                <div className={"iMobileDiv"}>
                  <CountryList
                    disabled={state_loading}
                    selectItem={(obj) => setState_countryCode(obj.code)}
                    countryQuery="All" //REG: 注册场景 , MOBILE: 手机, All:所有
                    showType="Small" //Large:大显示框， Small:小显示框
                  />
                  <FormItemInput
                    autoComplete={"on"}
                    isErr={!!state_mobile_status.errMsg}
                    type="tel"
                    inputMode="numeric"
                    // placeholder={intl.formatMessage({
                    //   id: "app.mobile",
                    // })}
                    disabled={state_loading}
                    value={state_mobile}
                    onInput={handleInputMobile}
                    onBlur={() => verify_mobile(1)}
                  />
                </div>
              </FormItem>
            )}

            <FormItem
              title={<FormattedMessage id="app.password" />}
              errMsg={state_password_status.errMsg}
            >
              <FormItemPassword
                // placeholder={intl.formatMessage({
                //   id: "app.password",
                // })}
                isErr={!!state_password_status.errMsg}
                popover={false}
                allowSpace={true}
                disabled={state_loading}
                value={state_password}
                onInput={setState_password}
                onBlur={() => verify_password(1)}
                onKeyPress={(e) => e.key === "Enter" && handleSubmit()}
              />
            </FormItem>

            <div className={"iLink"}>
              {/*<Link href={{ pathname: "/reset-password" }}>*/}
              <a
                href={getAbsoluteUrl({
                  pathname: "/reset-password",
                  locale: router.locale,
                  query: router.query,
                })}
              >
                <FormattedMessage id="login.forgotPwd" />
              </a>
              {/*</Link>*/}
            </div>

            <ButtonBig
              onClick={handleSubmit}
              style={{ width: "100%", marginTop: "24px" }}
              loading={state_loading}
            >
              <FormattedMessage id="app.login" />
            </ButtonBig>

            <div className={"iTip"}>
              {/*<Link href={{ pathname: "/register", query: router.query }}>*/}
              <a
                href={getAbsoluteUrl({
                  pathname: "/register",
                  locale: router.locale,
                  query: router.query,
                })}
              >
                <FormattedMessage id="saas.signUpXtAcc" />
              </a>
              {/*</Link>*/}
              {/*<FormattedMessage*/}
              {/*  id="login.isRegister"*/}
              {/*  values={{*/}
              {/*    0: (*/}
              {/*      <Link href={{ pathname: "/register", query: router.query }}>*/}
              {/*        <a>*/}
              {/*          <FormattedMessage id="login.registerNow" />*/}
              {/*        </a>*/}
              {/*      </Link>*/}
              {/*    ),*/}
              {/*  }}*/}
              {/*/>*/}
            </div>
          </div>
        </div>
      {/*)}*/}
      {qrUrl && (
        <div className="right">
          {status != "scanSuccess" && (
            <div className="sao">
              <div className="sao_title">
                <FormattedMessage id="app.sao" />
              </div>
              <div className="qr">
                <div className="qr_content">
                  <div className="code">
                    <QRCode
                      value={qrUrl} //value参数为生成二维码的链接
                      size={156} //二维码的宽高尺寸
                      fgColor="#000000" //二维码的颜色
                      imageSettings={{
                        // 配置二维码中间出现的logo信息
                        src: "data:image/png;base64,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", // logo的地址 可以是在线图片也可以是本地图片 没有默认值 类型为string
                        width: 40, // logo的宽度 默认值是整个二维码的10% 类型为number
                        height: 40, // logo的高度 默认值是整个二维码的10% 类型为number
                        excavate: false, // 是否是镂空状态 默认值false 类型为boolean
                      }}
                    />
                  </div>
                  {status == "EXPIRED" && (
                    <div className="expiration">
                      <div className="expiration_text">
                        <FormattedMessage id="app.expiration" />
                      </div>
                      <div onClick={create_key} className="expiration_button">
                        <FormattedMessage id="app.refresh" />
                      </div>
                    </div>
                  )}
                </div>
                <Image src={imgLogo} alt="mobile" />
              </div>
              <div className="sao_text">
                <FormattedMessage id="floxy.open" />
              </div>
              <div className="sao_text">
                <FormattedMessage id="app.saoTip" />
              </div>
            </div>
          )}

          {status == "scanSuccess" && (
            <div className="sao_success">
              <Image src={correct} alt="correct" />
              <div className="sao_success_title">
                <FormattedMessage id="app.success" />
              </div>
              <div className="sao_success_tip">
                <FormattedMessage id="app.sure" />
              </div>
            </div>
          )}
        </div>
      )}


      <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />
    </div>
  );
}
